export default "__VITE_ASSET__BOLDj66D__"